export default __webpack_public_path__ + "static/media/headerLogo.6ec934ef.svg";